module.exports = __webpack_public_path__ + "img/order_preparing.538dad00.png";